export default __webpack_public_path__ + "static/media/date.5a7b5e4d.svg";